module.exports = __webpack_public_path__ + "img/GT.4bfbc795.svg";